import zhCN from 'element-plus/es/locale/lang/zh-cn';
import jaJP from 'element-plus/es/locale/lang/ja';
import en from 'element-plus/es/locale/lang/en';

const localeConfig: Record<string, typeof zhCN> = {
  'zh-CN': {
    ...zhCN,
    el: {
      ...zhCN.el,
      pagination: {
        ...zhCN.el?.pagination,
        pagesize: '\u2009条/页'
      }
    }
  },
  'ja-JP': {
    ...jaJP,
    el: {
      ...jaJP.el,
      pagination: {
        ...jaJP.el?.pagination,
        pagesize: '\u2009件/ページ'
      }
    }
  },
  'en': {
    ...en,
    el: {
      ...en.el,
      pagination: {
        ...en.el?.pagination,
        pagesize: '\u2009/page'
      }
    }
  }
};

export const getElementPlusLocale = (lang: string) => {
  return localeConfig[lang] || localeConfig['ja-JP'];
};
